module.exports = "mutation ($id: ID!, $data: WebhookInput!) {\n  WebhookUpdate(id: $id, data: $data) {\n    id\n  }\n}\n"